import { useCallback } from 'react';
import { useI18n } from '../i18n';
import { withLocale } from '../lib/localePath';

/** Build a locale-prefixed path for the active language */
export function useLocalizedPath() {
  const { locale } = useI18n();
  return useCallback((path = '/') => withLocale(locale, path), [locale]);
}
